module.exports = __webpack_public_path__ + "media/images/people/1-f2305650cccf39b9cb484e1f55726911.jpg";